module.exports = __webpack_public_path__ + "fonts/Sen-Bold.ccb6aef2.ttf";